<template>
	<div class="nav-top">

		<!-- <div :class="brand==1 ?'brand-2':brand==2?'brand-1':'brand-3'">
			<el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="beforeLeave">
				<el-tab-pane label="首页" name="/allcontent"></el-tab-pane>
				<el-tab-pane label="专家智库" name="/expert/wisdom"></el-tab-pane>
				<el-tab-pane label="名校风采" name="/famous/school"></el-tab-pane>
				<el-tab-pane label="培训专区" name="/training/zone"></el-tab-pane>
				<el-tab-pane label="近期活动" name="/activity/index"></el-tab-pane>
				<el-tab-pane label="精彩直播" name="/broadcast/index"></el-tab-pane>
				<el-tab-pane label="在线学院" name="/online/school"></el-tab-pane>
				<el-tab-pane :label="'https://www.baidu.com'" target="_blank" href="https://www.example.com"></el-tab-pane>
				<el-tab-pane label="证书查询" name="/personal/service/certificate/index"></el-tab-pane>
				<el-tab-pane label="我的收藏" name="/collect/index"></el-tab-pane>
			</el-tabs>
		</div> -->
		<div :class="brand==1 ?'brand-2':brand==2?'brand-1':'brand-3'">
			<div class="tab-list">
				<div :class="activeName == item.url?'tab-items':'tab-item'" v-for="(item,index) in tabList" :key="index"
					@click="handleClick(item.url)">{{item.name}}</div>
			</div>
		</div>
		<div class="">
			<!-- <keep-alive> -->
			<router-view :key="key" />
			<!-- </keep-alive> -->
		</div>

	</div>

</template>

<script>
	import wisdom from '@/views/expert/wisdom.vue';
	import HomeView from '@/views/HomeView.vue';
	import school from '@/views/famous/school.vue';
	import zone from '@/views/training/zone.vue';
	import activity from '@/views/activity/index.vue';
	import broadcast from '@/views/broadcast/index.vue';
	import collect from '@/views/collect/index.vue';
	export default {
		components: {
			wisdom,
			HomeView,
			school,
			zone,
			activity,
			broadcast,
			collect
		},
		props: ['getSchoolName'],
		computed: {
			key() {
				return this.$route.path
			}
		},
		watch: {
			$route(to, from) {
				console.log('路由变化了', to)
				// console.log('123当前页面路由：' + to.path);
				// if(to.path == "/personal/index"){
				//     this.isShow = true;
				// }else if(to.path == "/allcontent"){
				//     this.isShow = false;
				// }
				// console.log('上一个路由：' + from);
				// if (to.path == '/expert/wisdom' || to.path == '/expert/expertDetail' || to.path == '/famous/school' ||
				//     to.path == '/famous/schoolDetail' || to.path == '/training/zone' || to.path == '/training/detail' ||
				//     to.path == '/activity/index' || to.path == '/activity/information' || to.path ==
				//     '/activity/payment' || to.path == '/activity/paymentSuccess' || to.path ==
				//     '/activity/paymentFail' || to.path == '/broadcast/index' || to.path ==
				//     '/activity/activityDetail' || to.path == '/collect/index') {
				//     this.brand = 2;
				// } else if (this.$route.path == '/allcontent') {
				//     this.brand = 1;
				// } else {
				//     this.brand = 3;
				// }
				if (this.$route.path == '/allcontent') {
					this.brand = 1;
				} else if (this.$route.fullPath.indexOf("/personal/") != -1) {
					this.brand = 3;
				} else {
					this.brand = 2;
				}
				if (this.$route.path) {
					this.activeName = this.$route.path;
					localStorage.setItem('activeName', this.activeName);
					this.$router.push(this.activeName)
				}

			},
		},
		data() {
			return {
				activeName: '/allcontent',
				isShow: true,
				brand: 1,
				tabList: [{
						name: '首页',
						url: '/allcontent'
					}, {
						name: '专家智库',
						url: '/expert/wisdom'
					}, {
						name: '名校风采',
						url: '/famous/school'
					}, {
						name: '培训专区',
						url: '/training/zone'
					}, {
						name: '近期活动',
						url: '/activity/index'
					}, {
						name: '精彩直播',
						url: '/broadcast/index'
					}, {
						name: '在线学院',
						url: '/online/school'
					},
					{
						name: '证书查询',
						url: '/personal/service/certificate/index'
					},
					{
						name: '我的收藏',
						url: '/collect/index'
					}
				],
			}
		},

		created() {
			// console.log(this.$route.fullPath, 'this.$route.fullPath')
			// this.handleClick();
			// this.init();
		},
		mounted() {
			if (this.$route.path == '/allcontent') {
				this.brand = 1;
			} else if (this.activeName.indexOf("/personal/") != -1) {
				this.brand = 3;
			} else {
				this.brand = 2;
			}
		},
		methods: {
			init() {
				// console.log(this.brand, '---')
			},
			handleClick(tab) {
				if (this.$route.path == '/allcontent') {
					this.brand = 1;
				} else if (this.activeName.indexOf("/personal/") != -1) {
					this.brand = 3;
				} else {
					this.brand = 2;
				}
				let token = localStorage.getItem('keyToken');
				if ((tab == '/collect/index' || tab == '/personal/service/certificate/index') && !token) {
					this.$root.loginShow = true;
					return;
				}
				if (tab == '/online/school') {
					window.open('https://applcqlstrc4234.h5.xiaoeknow.com');
					return;
				}
				if (tab == '/personal/service/certificate/index') {
					this.$router.push('/personal/service/certificate/index')
					return
				}
				this.getSchoolName(this.activeName)
				if (this.activeName == '/allcontent') {
					this.isShow = true;
				} else {
					this.isShow = false;
				}
				this.activeName = tab;
				localStorage.setItem('activeName', this.activeName);
				this.$router.push(this.activeName)
			},
			beforeLeave(tab) {
				console.log(tab, 'tab')
				// this.activeName = tab;
				let token = localStorage.getItem('keyToken');
				if ((tab == '/collect/index' || tab == '/personal/service/certificate/index') && !token) {
					// this.$message({
					// 	message: '账号暂未登录',
					// 	type: 'warning'
					// });
					this.$root.loginShow = true;
					return false;
				}
				if (tab == '/online/school') {
					window.open('https://applcqlstrc4234.h5.xiaoeknow.com');
					return false;
				} else if (tab == '/personal/service/certificate/index') {
					this.$router.push('/personal/service/certificate/index')
					// return false;
				} else {
					return true;
				}

			}
		}
	}
</script>

<style scoped>
	/deep/.el-tabs__header {
		margin: 0;
	}

	/deep/.el-carousel__button {
		width: 8px;
		height: 8px;
		background: rgba(0, 0, 0, 0.16);
		border-radius: 50%;
		opacity: 1;
	}

	/deep/.el-carousel__indicator.is-active button {
		width: 20px;
		height: 8px;
		background: #FFFFFF;
		border-radius: 20px 20px 20px 20px;
		opacity: 1;
	}

	/deep/.el-tabs__nav-scroll {
		padding-left: 19%;
		line-height: 55px;
	}

	/deep/.el-tabs__item {
		font-size: 16px;
		font-family: font3;
		color: #ffffff;
		font-weight: normal;
		text-align: center;
		width: 11.3%;
	}

	/deep/.el-tabs__item.is-active {
		font-size: 18px;
		font-family: font5;
	}

	/*    /deep/.el-tabs__item .is-top {
        width: 100%;
        font-size: 20px;
    } */

	/deep/.brand-2 .el-tabs__active-bar {
		width: 13%;
		background-color: #ffffff;
	}

	/deep/.el-tabs__nav-wrap::after {
		height: 0;
	}

	.nav-top {
		position: relative;
		width: 100%;
	}

	.brand {
		z-index: 100;
		color: #ffffff;
		width: 100%;
	}

	.brand-1 {
		background-color: #3377FF;
		width: 100%;
	}

	.brand-3 {
		display: none;
	}

	/deep/.brand-1 .el-tabs__active-bar {
		width: 0px !important;
	}

	.brand-2 {
		position: absolute;
		z-index: 100;
		color: #ffffff;
		width: 100%;
		background: rgba(0, 0, 0, 0.2);
	}

	/* /deep/.brand-1 .el-tabs__active-bar {height: 0; } */
	/* 移除下划线 */
	/deep/.el-tabs__nav {
		width: 76.5%;
	}

	/* /deep/.el-tabs__nav .is-top{width: 76.5%;} */
	/* 分辨率为1920x1080时 */
	@media (max-width: 1920px) {
		/* /deep/.el-tabs__item{max-width: 13.3%;}
          /deep/.el-tabs__item .is-top{max-width: 13.3%;}
          /deep/.el-tabs__active-bar{max-width: 13.3%;} */
		/* body {
          background-color: red;
        } */
		/*  */
	}

	/* 分辨率为1600*1200时 */
	@media (max-width: 1600px) {

		/deep/.el-tabs__item {
			font-size: 16px;
			font-family: font3;
			color: #ffffff;
			font-weight: normal;
			text-align: center;
			width: 10.8%;
		}

		/*        /deep/.el-tabs__item {
            font-size: 18px;
        }

        /deep/.el-tabs__active-bar {
            width: 11.3%;
        } */
	}

	/* 分辨率为1440x1050时 */
	@media (max-width: 1440px) {
		/*  body {
            background-color: red;
        } */
	}

	/* 分辨率为1280*854时 */
	@media (max-width: 1280px) {
		/*     body {
            background-color: red;
        } */
	}

	.tab-list {
		padding: 0 19%;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.tab-items {
		width: 133px;
		height: 56px;
		line-height: 56px;
		text-align: center;
		border-bottom: 2px solid #FFFFFF;
		font-weight: normal;
		font-size: 16px;
		color: #FFFFFF;
	}

	.tab-item {
		width: 133px;
		height: 56px;
		line-height: 56px;
		text-align: center;
		font-weight: normal;
		font-size: 16px;
		color: #FFFFFF;
	}
</style>
